import React from 'react'
import { 
  Container,
  OrderInfo,
  InfoText,
  VerticalLine,
  MessageBox,
  Title,
  Description,
  DoneCTA
 } from "./style/RMASuccessWMO.css"
import OrderItemWMO from './component/OrderItemWMO'

const RMASuccessWMO = ({
  isDesktop,
  DoneButton,
  orderItems,
  selectedImages,
  filesUpload,
  applicationData,
  successData,
  orderDate,
  type = "returns"
}) => {

  const MessageComponent = () => {
    if(type === 'returns') {
      return (
        <MessageBox>
        <Title>
          Return Request Has Been Submitted
        </Title>
        <Description>
          A return request confirmation has been sent to your email address{' '}
          <strong>{applicationData.email}</strong>.
          We&apos;ll review and process your request within 24-72 hours, and
          send a follow-up email with your Return Merchandise Authorization (RMA) number,
          shipping instructions, and refund estimate.
        </Description>
      </MessageBox>
      )
    }

    return (
      <MessageBox>
      <Title>
        Warranty Claim Request Has Been Submitted
      </Title>
      <Description>
        A warranty claim request confirmation has been sent to your email address{' '}
        <strong>{applicationData.email}</strong>.
        We&apos;ll review and process your request within 24-72 hours, and send a follow-up email.
      </Description>
    </MessageBox>
    )
  }

  return (
    <Container>
      <OrderInfo>
        <InfoText>
          Order #:{' '}
          <span>{applicationData.merchantOrderId}</span>
        </InfoText>
        <VerticalLine>|</VerticalLine>
        <InfoText>
          Order Date:{' '}
          <span>{orderDate}</span>
        </InfoText>
      </OrderInfo>
      <MessageComponent />
      <OrderItemWMO
        orderItems={orderItems}
        isDesktop={isDesktop}
        selectedImages={selectedImages}
        filesUpload={filesUpload}
        successData={successData}
        type={type}
      />
      <DoneCTA 
        id="Done Button"
        key="DoneButton"
        type="button"
        onClick={DoneButton}
      >
        Done
      </DoneCTA>
    </Container>
  )
}

export default RMASuccessWMO
